import { render, staticRenderFns } from "./RsaSchedaInfermieristicaAnamnesiPatologicaRemotaEditComponent.vue?vue&type=template&id=cab4d25e"
import script from "./RsaSchedaInfermieristicaAnamnesiPatologicaRemotaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaInfermieristicaAnamnesiPatologicaRemotaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports